import { Enumeration } from '@bp/shared/models/core/enum';

export class MerchantStatus extends Enumeration {

	static active = new MerchantStatus();

	static disabled = new MerchantStatus();

}
